import './style/B70.scss'

(async () => {
  // const streamline = document.querySelector('.streamline')
  const moreBtn = document.querySelector('.more-btn')
  const streamlineImg = document.querySelector('.streamline-image')
  const strImage = document.querySelector('.streamline-image img')
  const cover = document.querySelector('.cover')
  const coverClose = document.querySelector('.cover img')
  const {
    Swiper,
    Navigation,
    Pagination,
    Virtual,
    Autoplay
  } = await import( /* webpackChunkName: "swiper" */ 'swiper')
  Swiper.use([Navigation, Pagination, Virtual, Autoplay])
  new Swiper('.three-big .swiper', {
    direction: 'horizontal',
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletClass: 'my-bullet',
      bulletActiveClass: 'my-bullet-active',
      renderBullet: function (index, className) {
        let text;
        switch (index) {
          case 0:
            text = '70L大料箱'
            break;
          case 1:
            text = '快拆快洗'
            break;
          case 2:
            text = '实时称重'
            break;
        }
        return `<span class="${className}">${text}</span>`
      }
    }
  })



  new Swiper('.swiper2', {
    direction: "vertical",
    pagination: {
      clickable: true,
      // type: 'progressbar',
      bulletClass: 'my-bullet',
      bulletActiveClass: 'my-bullet-active',
      el: '.swiper-pagination2',
      renderBullet: function (index, className) {
        let text, title;
        switch (index) {
          case 0:
            title = 'M+半自动智能作业功能'
            text = '让临时小地块也能精准高效作业。'
            break;
          case 1:
            title = '自动扫边功能'
            text = '满足更多场景作业需求，不放过每一个边角作物。'
            break;
          case 2:
            title = '地块切割功能'
            text = '可自定义切割所圈地块。'
            break;
          case 3:
            title = 'AB点角度调节功能'
            text = '让不规则地块也轻松快速精准作业。'
            break;
        }
        return `<div class="${className}">
          <div>${title}</div>
          <div class="subtitle">${text}</div>
        </div>`
      }
    }
  })


  const mySwiper = new Swiper('.swiper3', {
    // 与 virtual 冲突
    // initialSlide: 1,
    observer: true,
    slidesPerView: 3,
    centeredSlides: true,
    spaceBetween: 0,
    autoplay: true,
    // loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    virtual: {
      addSlidesBefore: 3,
      addSlidesAfter: 3,
      slides: (function () {
        var slides = [];
        for (var i = 0; i < 75; i += 1) {
          slides.push(`https://static.qifeizn.com/resources/2023B70/shuffling/${i}.jpg`);
        }
        return slides;
      }()),
      renderSlide: function (slide) {
        return `<div class="swiper-slide" ><img src="${slide}"></img></div>`
      }
    },
    on: {
      observerUpdate: function () {
        // console.log(mySwiper.virtual.slides);
      },
    },
  });



  //  懒加载 当 video 标签出现在窗口内 加载视频
  const lazyLoading = (option) => {
    const io = new IntersectionObserver(entries => {
      console.log(entries);
      entries.forEach(item => {
        if (item.intersectionRect.height > 0) {
          item.target.autoplay = true;
          item.target.preload = 'auto'
          item.target.loop = true;
          item.target.play()
          io.unobserve(item.target)
        }
      })

    }, option)
    return io
  }


  const io = lazyLoading()

  document.querySelectorAll('video').forEach(item => {
    io.observe(item)
  })


  moreBtn.onclick = function () {
    streamlineImg.style.height = strImage.clientHeight + 'px';
    cover.style.display = 'block';
  }

  coverClose.onclick = function () {
    streamlineImg.style.height = 0;
    cover.style.display = 'none';
  }



})()

$('.video-button').click(function () {
  console.log('xx');
  var url = $(this).attr('dataId')
  $('.video-mask').show()
  $('.video-mask video').attr('src', url);
})
$('.video-close').click(function () {
  $('.video-mask').hide()
  $('.video-mask video').attr('src', '');
})